import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle';
import smoothscroll from 'smoothscroll-polyfill';
import 'splitting/dist/splitting.css';
import 'splitting/dist/splitting-cells.css';
import Splitting from 'splitting';

smoothscroll.polyfill();

document.querySelector('.teaser--about') &&
  document.querySelector('.teaser--about').addEventListener('click', () => {
    document
      .querySelector('.teaser--about + *')
      .scrollIntoView({ behavior: 'smooth' });
  });

document.querySelector('.scroll') &&
  document.querySelector('.scroll').addEventListener('click', () => {
    document
      .querySelector('#scriptsContent')
      .scrollIntoView({ behavior: 'smooth' });
  });

// Swiper.use([Navigation, Pagination]);

const largeSlider = () => {
  let largeSliders = document.querySelectorAll('.teaserSlider');
  let prevArrow = document.querySelectorAll('.slider-nav--prev');
  let nextArrow = document.querySelectorAll('.slider-nav--next');
  let swiperPagination = document.querySelectorAll('.swiper-pagination');
  largeSliders.forEach((slider, index) => {
    let sliderLength = slider.children[0].children.length;
    let result = sliderLength > 1 ? true : false;
    const swiper = new Swiper(slider, {
      loop: result,
      spaceBetween: 0,
      speed: 400,
      autoplay: {
        pauseOnMouseEnter: true,
        delay: 5000,
      },
      pagination: {
        el: swiperPagination[index],
        dynamicBullets: false,
        clickable: true,
      },
      navigation: {
        nextEl: nextArrow[index],
        prevEl: prevArrow[index],
      },
    });
  });
};

window.addEventListener('load', largeSlider);

// const teaserSlider = new Swiper('.teaserSlider', {
//   loop: true,
//   spaceBetween: 0,
//   speed: 800,
//   autoplay: {
//     pauseOnMouseEnter: true,
//     delay: 5000,
//   },
//   pagination: {
//     el: '#teaserSlider-pagination',
//     dynamicBullets: true,
//   },
//   navigation: {
//     nextEl: '#teaserSlider-nav--next',
//     prevEl: '#teaserSlider-nav--prev',
//   },
// });

const authorSwiper = new Swiper('.authorsSlider', {
  spaceBetween: 10,
  loop: true,
  grabCursor: true,
  slidesPerView: 2,
  slidesPerGroup: 2,
  pagination: {
    el: '#authorsSlider-pagination',
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '#authorSlider-nav--next',
    prevEl: '#authorSlider-nav--prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4,
    },
  },
});

gsap.registerPlugin(ScrollTrigger);

// LAZYLOAD GSAP STAGGER INTERSECTION OBSERVER

const teaserIntersect = (element) => {
  element.classList.add('has-intersected');
};

const lazyLoadElements = document.querySelectorAll(
    '[data-has-intersection-observer]'
  ),
  lazyOptions = { rootMargin: '0px 0px -20% 0px', treshold: 0.2 };

const lazyLoader = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    // const appearType = entry.target.dataset.appear
    if (entry.isIntersecting) {
      teaserIntersect(entry.target);
      observer.unobserve(entry.target);
    }
  });
}, lazyOptions);

lazyLoadElements.length &&
  lazyLoadElements.forEach((elm) => {
    lazyLoader.observe(elm);
  });

// site header height variable
const root = document.documentElement,
  header = document.querySelector('.site-header');

const calculateHeightVariables = () => {
  header &&
    root.style.setProperty('--headerHeight', header.offsetHeight + 'px');
  root.style.setProperty('--windowHeight', window.innerHeight + 'px');
};
const calculateMobileHeight = () => {
  root.style.setProperty('--windowMobileHeight', window.innerHeight + 'px');
};
calculateMobileHeight();
calculateHeightVariables();

// window.addEventListener('resize', calculateHeightVariables);

// BOOKS

const bookTab = document.querySelectorAll('.bookTab');

bookTab.length &&
  bookTab.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      if (!e.target.classList.contains('active')) {
        const active = document.querySelector('.active');
        const newTab = e.target.getAttribute('data-tab');
        document
          .querySelector('.book-meta')
          .setAttribute('data-current', newTab);
        active.classList.remove('active');
        e.target.classList.add('active');

        const tabs = document.querySelectorAll('.book-meta__content');
        tabs.forEach((elm) => {
          elm.classList.remove('active');
        });
        document.querySelector('#' + newTab).classList.add('active');
      }
    });
  });

// Scripts page
function rotateBack(i) {
  return (180 / 8) * i;
}

const tl_scripts = gsap.timeline();

const scriptsItems = document.querySelectorAll('.scripts__item');
if (scriptsItems.length > 0) {
  tl_scripts
    .addLabel('start')
    .to(
      '.scripts__circle',
      { scale: 1, xPercent: -50, duration: 1, yPercent: 0 },
      'start'
    );
  scriptsItems.forEach((item, index) => {
    tl_scripts.fromTo(
      item,
      {
        scaleX: 0,
        opacity: 0,
      },
      // .fromTo(item, {
      // 	xPercent: random(-200,200, 1),
      // 	yPercent: random(0,-2200, 1),
      // 	opacity: 0,
      // },
      {
        scaleX: 1,
        opacity: 1,
        xPercent: 0,
        yPercent: 0,
        rotation: rotateBack(index),
        duration: 0.5,
        ease: 'power3.out',
      },
      '<.1'
    );
  });
  tl_scripts.fromTo(
    '.scripts__step',
    { y: 100, opacity: 0 },
    { y: 0, opacity: 1, duration: 3, stagger: 0.2, ease: 'expo.out' },
    'start'
  );
}

const body = document.querySelector('body'),
  navPrimary = document.querySelector('.nav-primary'),
  menuItems = document.querySelectorAll(
    '.navItem, .nav .menu-item, .some-icon, .mobile-search'
  ),
  burger = document.querySelector('.burger');

if (burger) {
  const tl_burger = gsap.timeline({ paused: true });
  // if (tl_burger.reversed()) {
  tl_burger.to(navPrimary, {
    xPercent: -100,
    ease: 'power2.out',
    duration: 0.5,
  });
  // }
  tl_burger
    .to(
      '.burger__item',
      {
        y: 0,
        transformOrigin: 'center center',
        duration: 0.3,
        ease: 'back.inOut(4)',
      },
      '<'
    )
    .to(
      '.burger__item:nth-child(1)',
      {
        rotate: '-45deg',
        duration: 0.3,
        ease: 'back.out(3)',
        backgroundColor: '#fff',
      },
      '<.2'
    )
    .to(
      '.burger__item:nth-child(2)',
      {
        rotate: '45deg',
        duration: 0.3,
        ease: 'back.out(3)',
        backgroundColor: '#fff',
      },
      '<'
    );
  // if (!tl_burger.reversed()) {

  //   tl_burger.to(
  //     navPrimary,
  //     { yPercent: '100%', ease: 'power2.out', duration: 0.25 },
  //     '<'
  //   );
  // }
  tl_burger.to(
    menuItems,
    { x: 0, opacity: 1, stagger: 0.1, duration: 0.45, ease: 'back.out(3)' },
    '<'
  );

  burger.addEventListener('click', () => {
    burger.getAttribute('aria-expanded') == 'false'
      ? burger.setAttribute('aria-expanded', 'true')
      : burger.setAttribute('aria-expanded', 'false');
    burger.getAttribute('aria-label') == 'Vis menu'
      ? burger.setAttribute('aria-label', 'Skjul menu')
      : burger.setAttribute('aria-label', 'Vis menu');
    tl_burger.reversed() || tl_burger.paused()
      ? tl_burger.timeScale(1).restart()
      : tl_burger.timeScale(2).reverse();
    navPrimary.classList.toggle('active');
    body.classList.toggle('show-menu');
  });
}

// FORMS
const inputFields = document.querySelectorAll('.form__input');
inputFields.forEach((field) => {
  field.addEventListener('input', (e) => {
    !e.target.value
      ? field.setAttribute('data-empty', true)
      : field.setAttribute('data-empty', false);
  });
});

// FIT VIDEOS TO ASPECT RATIO
// List of Video Vendors embeds you want to support
var players = ['iframe[src*="youtube.com"]', 'iframe[src*="vimeo.com"]'];

// Select videos
var fitVids = document.querySelectorAll(players.join(','));

// If there are videos on the page...
if (fitVids.length) {
  // Loop through videos
  for (let i = 0; i < fitVids.length; i++) {
    // Get Video Information
    const fitVid = fitVids[i],
      width = fitVid.getAttribute('width'),
      height = fitVid.getAttribute('height'),
      aspectRatio = height / width,
      parentDiv = fitVid.parentNode;

    // Wrap it in a DIV
    const div = document.createElement('div');
    div.className = 'fitVids-wrapper';
    div.style.paddingBottom = aspectRatio * 100 + '%';
    parentDiv.insertBefore(div, fitVid);
    fitVid.remove();
    div.appendChild(fitVid);

    // Clear height/width from fitVid
    fitVid.removeAttribute('height');
    fitVid.removeAttribute('width');
  }
}

// gsap.to(document.documentElement, { duration: 5, '--my-variable': '100' });

Splitting();

// ABOUT-PAGE HERO ANIMATION

const heroContent = document.querySelectorAll('.hero__content');
const heroTitle = document.querySelectorAll('.hero__title .word ');
if (heroTitle.length > 0) {
  const hero_intro = gsap.timeline();
  hero_intro.to(heroTitle, {
    stagger: 0.05,
    duration: 0.75,
    opacity: 1,
    '--animateY': 0,
    ease: 'power3.out',
  });
}

const heroFigure = document.querySelector('.hero__figure');
if (heroFigure) {
  const tl_hero_scroll = gsap.timeline();

  tl_hero_scroll
    .set(heroContent, {opacity: 1})
    .to('.hero__figure', { yPercent: 0, scale: 1 })
    .to('.hero__title', { y: '-3vh' }, '<');

  ScrollTrigger.create({
    animation: tl_hero_scroll,
    trigger: '.hero__figure',
    start: () => 'top ' + heroFigure.offsetTop,
    end: 'bottom center',
    scrub: 0.5,
    // pinSpacing: false,
    // pin: true,
    // markers: true,
  });
}

// PAGE SCRIPTS

const scripts = document.querySelector('.scripts'),
  title_scripts = document.querySelectorAll('.scripts__title .word'),
  summary_scripts = document.querySelector('.page-summary'),
  box_scripts = document.querySelector('.scripts__box'),
  scripts_tl = gsap.timeline();

if (title_scripts.length !== 0) {
  scripts_tl
    .to(title_scripts, {
      stagger: 0.03,
      duration: 0.5,
      opacity: 1,
      '--animateY': 0,
      ease: 'power3.out',
    })
    .to(summary_scripts, { y: 0, opacity: 1, ease: 'power3.out' }, '<.2')
    .to(
      box_scripts,
      { y: 0, opacity: 1, duration: 1.2, ease: 'power3.out' },
      '<'
    );
}

const pressFilter = document.querySelector('#pressfilter');
const keywords = document.querySelectorAll('[data-keywords]');

pressFilter &&
  pressFilter.addEventListener('search', () => {
    keywords.forEach((elm) => {
      elm.classList.remove('hide');
    });
  });

pressFilter &&
  pressFilter.addEventListener('keyup', (e) => {
    const searchTerm = e.target.value.toLowerCase().trim();
    if (searchTerm.length === 0) {
      keywords.forEach((elm) => {
        elm.classList.remove('hide');
      });
    }
    if (searchTerm.length === 1) {
      keywords.forEach((elm) => {
        elm.classList.add('hide');
      });
    }

    keywords.forEach((elm) => {
      const filter = elm.dataset.keywords.toLowerCase().trim();
      filter.includes(searchTerm)
        ? elm.classList.remove('hide')
        : elm.classList.add('hide');
    });
  });

// LOGO ANIMATION
const tl_logo = gsap.timeline(),
  tl_preloader = gsap.timeline(),
  preloaderItems = document.querySelectorAll('.skakke__item'),
  preloaderContainer = document.querySelector('.skakke__container');

if (preloaderItems.length !== 0) {
  tl_logo.fromTo(
    preloaderItems,
    {
      opacity: 0,
      rotate: function (index) {
        if (index == 0) {
          return '0deg';
        } else {
          return (179.9 / 8) * (index - 1) + 'deg';
        }
      },
    },
    {
      duration: 0.95,
      opacity: 1,
      stagger: 0.05,
      rotate: function (index) {
        return (180 / 8) * (0 + index) + 'deg';
      },
    }
  );
  tl_preloader
    .addLabel('appear')
    .fromTo(
      preloaderContainer,
      { yPercent: 100, opacity: 0 },
      { yPercent: 0, opacity: 1, duration: 0.5, ease: 'power3.out' },
      'appear'
    )
    .add(tl_logo, 'appear');
  // .to(preloaderContainer, {yPercent: -100, opacity: 0, ease: 'back.in(1.5)', duration: .3})
  // .call(togglePreloader);
}

const toggleSearch = document.querySelectorAll('.toggleSearch');
toggleSearch.forEach((item) => {
  item.addEventListener('click', () => {
    const siteSearch = document.querySelector('.site-search-wrapper');
    siteSearch.classList.toggle('visible');
    if (siteSearch.classList.contains('visible')) {
      document.querySelector('.search-field').focus();
    }
  });
});


// Fullscreen article header

const headerFS = document.querySelector('.header-fs');
if (headerFS != null || headerFS != undefined) {

  // scroll to content
   document
     .querySelector('.header-fs__scroll')
     .addEventListener('click', (e) => {
       e.preventDefault()
       document
         .querySelector('#top')
         .scrollIntoView({ behavior: 'smooth' });
     });

  // header image scrolltrigger

  const article_header_tl = gsap.timeline();
  article_header_tl.fromTo(
    headerFS,
    {
      yPercent: 0 },
    {
      yPercent: -50,
      ease: 'none',
      scrollTrigger: {
        trigger: headerFS,
        start: 'top top',
        end: 'bottom 10%',
        scrub: true,
      },
    }
  );
}


const toggleDropdown = document.querySelector('.toggleDropdown')
toggleDropdown && toggleDropdown.addEventListener('click', () => {
  toggleDropdown.closest('.dropdown').classList.toggle('active')
})


